<div class="secondary-navbar" *ngIf="isDesktop && showNav">
    <div
        class="item browse"
        #browseAnchor
        (click)="dropdowns.toggleBrowseDropdown()"
        tabindex="0">
        Browse
        <span *ngIf="!browseDropdown">
            <i class="fa fa-chevron-down"></i>
        </span>
        <span *ngIf="browseDropdown">
            <i class="fa fa-chevron-up"></i>
        </span>
    </div>
    <clark-context-menu
        class="dropdown"
        *ngIf="browseDropdown"
        [anchor]="browseAnchor"
        (close)="dropdowns.closeAll()">
        <div #contextMenu>
            <ul>
                <li [routerLink]="'/browse'">Browse Curriculum</li>
                <li [routerLink]="'/playlists'">Browse Playlists</li>
                <li (click)="utilityService.openCard()">Browse Resources</li>
            </ul>
        </div>
    </clark-context-menu>
    <div
        class="item collections"
        id="collectionsAnchor"
        #collectionsAnchor
        (click)="dropdowns.toggleCollectionDropdown()"
        tabindex="0">
        Collections
        <span *ngIf="!collectionsDropdown">
            <i class="fa fa-chevron-down"></i>
        </span>
        <span *ngIf="collectionsDropdown">
            <i class="fa fa-chevron-up"></i>
        </span>
    </div>
    <div
        class="item topics"
        #topicsAnchor
        (click)="dropdowns.toggleTopicDropdown()"
        tabindex="0">
        Topics
        <span *ngIf="!topicDropdown">
            <i class="fa fa-chevron-down"></i>
        </span>
        <span *ngIf="topicDropdown">
            <i class="fa fa-chevron-up"></i>
        </span>
    </div>
    <clark-context-menu
        *ngIf="topicDropdown"
        [anchor]="topicsAnchor"
        (close)="dropdowns.closeAll()">
        <div #contextMenu>
            <ul>
                <li
                    *ngFor="let t of topics"
                    (click)="dropdowns.setTopic(t._id)">
                    {{ t.name }}
                </li>
            </ul>
        </div>
    </clark-context-menu>
    <div
        class="item resources"
        #resourcesAnchor
        (click)="dropdowns.toggleResourcesDropdown()"
        tabindex="0">
        Other Resources
        <span *ngIf="!resourcesDropdown">
            <i class="fa fa-chevron-down"></i>
        </span>
        <span *ngIf="resourcesDropdown">
            <i class="fa fa-chevron-up"></i>
        </span>
    </div>
    <clark-context-menu
        class="dropdown"
        *ngIf="resourcesDropdown"
        [anchor]="resourcesAnchor"
        (close)="dropdowns.closeAll()">
        <div #contextMenu>
            <ul>
                <li
                    *ngFor="let r of externalResources"
                    (click)="dropdowns.linkOut(r.link)">
                    {{ r.name }}
                </li>
            </ul>
        </div>
    </clark-context-menu>
</div>

<div>
    <clark-collections-dropdown
        *ngIf="collectionsDropdown"
        (close)="dropdowns.closeAll()"></clark-collections-dropdown>
</div>
